/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { PlaceNegotiableQuoteOrderResponse } from '@/order/types';
import { OrderDataModel } from '../models';
import { transformOrderData } from './transform-order-details';

export const transformPlaceNegotiableQuoteOrder = (
  response: PlaceNegotiableQuoteOrderResponse
): OrderDataModel | null => {
  const orderData = response?.data?.placeNegotiableQuoteOrder?.orderV2;
  if (!orderData) return null;
  return transformOrderData(orderData);
};
